export default __webpack_public_path__ + "static/banner-budgeting-for-your-honeymoon-f572e7813ea0d63a2e73a6f89c9a9173.jpg";